<template>
	<button
		type="button"
		class="flex h-6 w-full items-center justify-center gap-0.5 rounded-sm text-xs font-medium text-won-green md:hidden"
		:aria-expanded="modelValue"
		@click="emit('update:modelValue', !modelValue)"
	>
		Plan Details
		<ChevronDownIcon
			:class="['size-4 transition-transform', { 'rotate-180': modelValue }]"
			aria-hidden="true"
		/>
	</button>
</template>

<script setup>
import { ChevronDownIcon } from '@heroicons/vue/20/solid';

/**
 * The mobile "Plan Details" disclosure. Desktop always shows the details, so it is hidden there.
 */
defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['update:modelValue']);
</script>
